import makeRequest from './client';

export type SnapshotComparisonApplicationsParams = {
  center?: string;
  application_number?: string;
  qc_status?: boolean;
  change_detection_status?: boolean;
  page?: number;
  page_size?: number;
};

export const getSnapshotComparisonApplications = (params: SnapshotComparisonApplicationsParams) => {
  const searchParams = new URLSearchParams();

  if (params.center) {
    searchParams.append('center', params.center);
  }
  if (params.application_number) {
    searchParams.append('application_number', params.application_number);
  }
  if (params.qc_status !== undefined) {
    searchParams.append('qc_status', String(params.qc_status));
  }
  if (params.change_detection_status !== undefined) {
    searchParams.append('change_detection_status', String(params.change_detection_status));
  }

  searchParams.append('page', String(params.page ?? 0));
  searchParams.append('page_size', String(params.page_size ?? 20));

  return makeRequest(`/snapshot_change_detection/application?${searchParams}`, 'GET');
};
